import React, { useMemo } from 'react';
import styles from './VehicleBundles.module.scss';
import { Button, Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { newCoEffectiveDate } from './../../../../../helpers/date';

 
const VehicleBundles = ({ onNoThanks, onBack, onAddBetter, onAddBest, onSaveAndExit, currentEnhancement, effectiveDate, policy}) => {
	const bundleOptionDisclaimers = useMemo(() => {
		return {
			1: 'Deductible applies',
			2: 'included with liability only',
		};
	}, []);


    const isBefore = moment(policy.term.effectiveDate).isBefore(newCoEffectiveDate);
	const bundleOptions = useMemo(
		() => [
			{
                title() { return (<span>Rental reimbursement - we pay for a rental car if your car isn't drivable ($20 a day/$600 max)`  </span>)},
                good: true,
                better: true,
                best: true,
            },
            {
                title() { return (<span>New car replacement - we pay for replacement cost of current and previous model year </span>)},
                good: false,
                better: true,
                best: true,
                disclaimers: ['1'],
            },
            {
                title() { return (<span>Rental car company loss of revenue - we pay the rental car company $40 a day/$1200 max when you damage a rental car that can't be rented </span>)},
                good: false,
                better: true,
                best: true,
                disclaimers: ['1'],
            },
            {
                title() { return (<span>Emergency travel expenses - we pay up to $600 for meals, lodging and transportation if you're 100+ miles from home and require emergency road service </span>)},
                good: false,
                better: true,
                best: true,
            },
            {
                title() { return (<span>Personal property/audio visual - we pay up to $500 for loss to items in your car </span>)},
                good: false,
                better: true,
                best: true,
                disclaimers: ['2'],
            },
            {
                title() { return (<span>Fire department service charge - we pay up to $500 when the fire department is called to save or limit damage to your car </span>)},
                good: false,
                better: true,
                best: true,
                disclaimers: ['2'],
            },
            {
                title() { return (<span>Air bag deployed - we pay up to $1000 to recharge accidental or uninteded deployment </span>)},
                good: false,
                better: true,
                best: true,
                disclaimers: ['2'],
            },
            {
                title() { return (<span>Locksmith services - we pay up to $500 to gain acess to your car </span>)},
                good: false,
                better: true,
                best: true,
                disclaimers: ['2'],
            },
            {
                title() { return (<span>Trailer damage - we pay up to $1500 for damage to a trailer you don't own </span>)},
                good: false,
                better: true,
                best: true,
            },
            {
                title() { return (<span>Repair/replacement of safety glass - we pay for repair or replacement of safety glass </span>)},
                good: false,
                better: false,
                best: true,
            },
            {
                title() { return (<span>Rental reimbursement - we pay an additional $20 a day/$1200 max for a rental car if your car isn't drivable</span>)},
                good: false,
                better: false,
                best: true,
            },
		],
		[]
	);
	const bundleOptionsNewCo = useMemo(
		() => [
			{
                title() { return (<span>Rental reimbursement - we pay for a rental car if your car isn't drivable ($40 a day/$1200 max) </span>)},
                 good: true,
                better: true,
                best: true,
            },

            {
                title() { return (<span>New car replacement - we pay for replacement cost of current and previous model year </span>)},
                good: false,
                better: true,
                best: true,
                disclaimers: ['1'],
            },
            {
                title() { return (<span>Rental car company loss of revenue - we pay the rental car company $40 a day/$1200 max when you damage a rental car that can't be rented </span>)},
                good: false,
                better: true,
                best: true,
                disclaimers: ['1'],
            },
            {
                title() { return (<span>Emergency travel expenses - we pay up to $600 for meals, lodging and transportation if you're 100+ miles from home and require emergency road service </span>)},
                good: false,
                better: true,
                best: true,
            },
            {
                title() { return (<span>Personal property/audio visual - we pay up to $500 for loss to items in your car </span>)},
                good: false,
                better: true,
                best: true,
                disclaimers: ['2'],
            },
            {
                title() { return (<span>Fire department service charge - we pay up to $500 when the fire department is called to save or limit damage to your car </span>)},
               good: false,
                better: true,
                best: true,
                disclaimers: ['2'],
            },
            {
                title() { return (<span>Air bag deployed - we pay up to $1000 to recharge accidental or uninteded deployment </span>)},
               good: false,
                better: true,
                best: true,
                disclaimers: ['2'],
            },
            {
                title() { return (<span>Locksmith services - we pay up to $500 to gain acess to your car </span>)},
               good: false,
                better: true,
                best: true,
                disclaimers: ['2'],
            },
            {
                title() { return (<span>Trailer damage - we pay up to $1500 for damage to a trailer you don't own </span>)},
                good: false,
                better: true,
                best: true,
            },
            {
                title() { return (<span>Repair/replacement of safety glass - we pay for repair or replacement of safety glass </span>)},
                good: false,
                better: false,
                best: true,
            },
            {
                title() { return (<span>Rental reimbursement - we pay an <b>additional</b> $10 a day/$300 max for a rental car if your car isn't drivable </span>)},
                good: false,
                better: false,
                best: true,
            },
		],
		[]
	);

	const hasBetter = useMemo(() => currentEnhancement === 'better', [currentEnhancement]);
	
	return (
		<div>
			<Table unstackable>
				<Table.Header>
					<Table.Row textAlign='center'>
						<Table.HeaderCell></Table.HeaderCell>
						<Table.HeaderCell>What you have today included</Table.HeaderCell>
						{!hasBetter && (
							<Table.HeaderCell>
								<b>Make it better bundle</b>
								<div>$35 a year for all covered vehicles</div>
								<Button id="bundleMIBBtn" primary onClick={onAddBetter}>
									Add
								</Button>
							</Table.HeaderCell>
						)}

						<Table.HeaderCell>
							<b>Make it even better bundle</b>
							<div>${hasBetter ? 30 : 65} a year for all covered vehicles</div>
							<Button id="bundleEBBtn" primary onClick={onAddBest}>
								Add
							</Button>
						</Table.HeaderCell>
					</Table.Row>
				</Table.Header>
				<Table.Body>
					{isBefore ?
					bundleOptions.map((option, i) => {
						return (
							<Table.Row key={i} textAlign='center'>
								<Table.Cell>
									{option.title()}
									{(option.disclaimers || []).map((d, i) => (
										<sup key={i}>{d}</sup>
									))}
								</Table.Cell>
								{!hasBetter && <Table.Cell>{option.good && <div>⬤</div>}</Table.Cell>}
								<Table.Cell>{option.better && <div>⬤</div>}</Table.Cell>
								<Table.Cell>{option.best && <div>⬤</div>}</Table.Cell>
							</Table.Row>
						);
					}):
					bundleOptionsNewCo.map((option, i) => {
						return (
							<Table.Row key={i} textAlign='center'>
								<Table.Cell>
									{option.title()}
									{(option.disclaimers || []).map((d, i) => (
										<sup key={i}>{d}</sup>
									))}
								</Table.Cell>
								{!hasBetter && <Table.Cell>{option.good && <div>⬤</div>}</Table.Cell>}
								<Table.Cell>{option.better && <div>⬤</div>}</Table.Cell>
								<Table.Cell>{option.best && <div>⬤</div>}</Table.Cell>
							</Table.Row>
						);
					})
				}
				</Table.Body>
			</Table>
			<div>
				{Object.keys(bundleOptionDisclaimers).map((key, i) => {
					return (
						<div key={i}>
							<sup>{key}</sup> - {bundleOptionDisclaimers[key]}
						</div>
					);
				})}
			</div>
			<div className={styles.buttons}>
				<Button id="noThanksBtn" primary onClick={onNoThanks}>
					No Thanks
				</Button>
				<Button id="saveAndExitBtn" primary onClick={onSaveAndExit}>
					Save and Exit
				</Button>
				<Button id="backBtn" primary onClick={onBack}>
					Back
				</Button>
			</div>
		</div>
	);
};

VehicleBundles.propTypes = {
	onNoThanks: PropTypes.func.isRequired,
	onBack: PropTypes.func.isRequired,
	onAddBetter: PropTypes.func.isRequired,
	onAddBest: PropTypes.func.isRequired,
	onSaveAndExit: PropTypes.func.isRequired,
};

export default VehicleBundles;
